import {
  OperationBriefForm,
  OperationRequestPayload,
} from 'models/OperationRequest';

import {
  WeekPlanCells,
  computePlanMetrics,
} from '../components/OpsWeekPlanner';
import { planCellsToTurns } from './operationCatalogs';

interface BuildPayloadParams {
  status: 'draft' | 'submitted';
  brief: OperationBriefForm;
  selectedStoreIds: number[];
  cells: WeekPlanCells;
}

/** Arma el JSON canónico para borrador / envío al service. */
export function buildOperationRequestPayload({
  status,
  brief,
  selectedStoreIds,
  cells,
}: BuildPayloadParams): OperationRequestPayload {
  const turns = planCellsToTurns(selectedStoreIds, cells, brief);
  const metrics = computePlanMetrics(selectedStoreIds, cells, brief);

  return {
    status,
    brief: {
      ...brief,
      blocks: {
        am: { ...brief.blocks.am },
        pm: { ...brief.blocks.pm },
        full: { ...brief.blocks.full },
      },
    },
    plan: {
      storeIds: [...selectedStoreIds],
      cells: { ...cells },
      turns,
    },
    metrics: {
      turnos: metrics.turnos,
      people: metrics.people,
      hours: metrics.hours,
      cost: metrics.cost,
    },
  };
}
